<template>
<div style="padding-top: 90px">
    <div class="item m-b-20">
        <div class="tips">请输入您想要创建或加入的公司名称</div>
    </div>
    <div class="item flex">
            <el-input
            class="com-input"
            placeholder="请输入公司名称"
            icon="search"
            v-model="keyword"
            :on-icon-click="search">
            </el-input>
        <div class="primary-btn absolute" @click="search" >检索以完成创建</div>
    </div>
    <div v-if="isSearched">
        <div class="info flex flex-between item">
            <p>共{{total}}个结果</p>
            <div class="goreg" @click="gocreate">没有找到？点击创建新企业</div>
        </div>
        <ul class="rlist" v-if="rows.length">
            <li class="item flex flex-between company-item" v-for="item in rows" :key="item.id">
                <div class="company-detail flex">
                    <div class="logo">
                        <img :src="item.logo" />
                    </div>
                    <div class="">{{item.name}}</div>
                </div>
                <button class="company-btn"  v-if="item.status == 0" @click="join(item)" >加入</button>
                <button class="company-btn"  v-if="item.status == 1" >已加入</button>
                <button class="company-btn"  v-if="item.status == 2" >审核中</button>
                <button class="company-btn"  v-if="item.status == 3" >禁用中</button>
            </li>
        </ul>
    </div>
</div>
</template>
<script>
 export default{
     data(){
         return {
             keyword:'', // 关键字
             pageNum:1,
             pageSize:10,
             isSearched:false, // 是否查询
             rows:[], // 查询到的arr
             total:0,
//             btntxt:'查询'
         }
     },
     created(){

     },
     methods:{
         // 搜索
         search(){
            this.axios.get('/wapi/company/pageJoin?keyword='+this.keyword + '&pageNum='+this.pageNum + '&pageSize='+this.pageSize)
            .then(res => {
               if(res.total*1 > 0){
                    this.rows = res.rows;
                    this.total = res.total;
               }
               this.isSearched = true
            })
         },
         currentChange(val){
           this.pageNum = val;
           this.search();
        },
        //  加入
        join(item){
            this.$router.push({path:'/register/hrapply?id='+ item.id})
        },
         //创建
         gocreate(){
             this.$router.push({path:'/register/create?searchtxt='+this.keyword})
         }
     }
 }
</script>
<style scoped lang="less">
@import url('../../assets/less/base.less');
@main-cont-width: 300px;
.item{
    width: @main-cont-width;
    position: relative;
    .tips{
        text-align: center;
        color: @color-gray;
        font-size: 16px;
    }
    .absolute{
        position: absolute;
        left: @main-cont-width + 24px;
    }
    .primary-btn{
        width: 148px;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        font-weight: 400;
    }
    &.info{
        line-height: 50px;
        font-size: 12px;
        margin-bottom: 12px;
        .goreg{
            color: #FA6400;
            cursor: pointer;
        }
    }
}
.company-item{
    height: 28px;
    line-height: 28px;
    font-size: 14px;
    color: #333333;
    margin-bottom: 16px;
    .logo{
        height: 28px;
        width: 28px;
        margin-right: 15px;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .company-btn{
        width: 69px;
        height: 28px;
        line-height: 28px;
        background: #EAF4FF;
        border-radius: 2px;
        border: 1px solid @color-primary;
        color: @color-primary;;
    }
}
</style>




// WEBPACK FOOTER //
// join.vue?43ef1dfc